import { Http } from '@mygpt/app/http';

export interface DeleteDictionaryPrarms {
  aiId: string;
  dictionaryIds: string[];
}

/**
 * 删除字典
 * @param params
 * @returns
 */
export const deleteDictionaryService = (params: DeleteDictionaryPrarms) => {
  const { delete: deleteFn } = Http.use();
  return deleteFn(`/robots/${params.aiId}/dictionaries`, { data: { dictionary_ids: params.dictionaryIds } });
};
